import React, { useState, useEffect } from 'react';

const CONSENT_KEY = 'propatlas_consent_v1';
export const CONSENT_VERSION = '1.0';

/**
 * Returns the stored consent record, or null if no decision has been made.
 */
export function getStoredConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export default function ConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = getStoredConsent();
    // Show if no decision stored, or if the stored version is outdated
    if (!stored || stored.version !== CONSENT_VERSION) {
      setVisible(true);
    }
  }, []);

  const record = (accepted) => {
    localStorage.setItem(
      CONSENT_KEY,
      JSON.stringify({
        accepted,
        version: CONSENT_VERSION,
        decided_at: new Date().toISOString(),
      })
    );
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 9999,
      background: 'var(--paper-2)',
      borderTop: '2px solid var(--hairline)',
      boxShadow: '0 -4px 24px rgba(0,0,0,0.12)',
      padding: '16px 24px',
    }}>
      <div style={{ maxWidth: 960, margin: '0 auto', display: 'flex', gap: 20, alignItems: 'center', flexWrap: 'wrap' }}>
        <div style={{ flex: 1, minWidth: 260, fontSize: 13, color: 'var(--ink-2)', lineHeight: 1.55 }}>
          <span style={{ fontWeight: 600, color: 'var(--forest)', marginRight: 6 }}>
            Your privacy
          </span>
          PropAtlas uses essential session cookies to keep you securely signed in.
          We do not sell your data or use tracking or advertising cookies.
          By clicking <strong>Accept</strong> you agree to our{' '}
          <a
            href="https://propatlas.com.au/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'var(--forest)', fontWeight: 500 }}
          >
            Privacy Policy
          </a>
          {' '}and{' '}
          <a
            href="https://propatlas.com.au/terms"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'var(--forest)', fontWeight: 500 }}
          >
            Terms of Service
          </a>{' '}
          (v{CONSENT_VERSION}).
        </div>

        <div style={{ display: 'flex', gap: 10, flexShrink: 0, flexWrap: 'wrap' }}>
          <button
            className="btn"
            onClick={() => record(false)}
            style={{ whiteSpace: 'nowrap' }}
          >
            Decline
          </button>
          <button
            className="btn primary"
            onClick={() => record(true)}
            style={{ whiteSpace: 'nowrap' }}
          >
            Accept &amp; Continue
          </button>
        </div>
      </div>
    </div>
  );
}
